import { Home, PackageOpen, ShoppingBag, Sparkles, UserRound } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/context/CartContext";

const primaryLinks = [
  { label: "Home", to: "/", icon: Home, testId: "mobile-nav-home" },
  { label: "Menu", to: "/menu", icon: PackageOpen, testId: "mobile-nav-menu" },
  { label: "Box", to: "/box/2", icon: Sparkles, testId: "mobile-nav-box" },
  { label: "Account", to: "/account", icon: UserRound, testId: "mobile-nav-account" },
];

function isCurrent(pathname, target) {
  if (target === "/") {
    return pathname === "/";
  }
  return pathname.startsWith(target);
}

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { count, setDrawerOpen } = useCart();
  const hideForPurchaseFlow = pathname.startsWith("/checkout") || pathname.startsWith("/cart");
  const hideForConfirmation = pathname.startsWith("/order/");

  if (hideForPurchaseFlow || hideForConfirmation || pathname.startsWith("/admin")) {
    return null;
  }

  return (
    <nav
      aria-label="Mobile navigation"
      data-testid="mobile-bottom-nav"
      className={
        "fixed inset-x-0 bottom-0 z-50 border-t border-line bg-ivory/95 px-1 "
        + "pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden"
      }
    >
      <div className="mx-auto grid h-16 max-w-md grid-cols-5">
        {primaryLinks.slice(0, 3).map(({ label, to, icon: Icon, testId }) => {
          const active = isCurrent(pathname, to);
          return (
            <Link
              key={to}
              to={to}
              data-testid={testId}
              aria-current={active ? "page" : undefined}
              className={
                "flex flex-col items-center justify-center gap-1 text-[10px] font-semibold "
                + "uppercase tracking-[0.12em]"
              }
            >
              <Icon
                size={19}
                strokeWidth={active ? 2 : 1.5}
                className={active ? "text-espresso" : "text-espresso-light"}
                aria-hidden="true"
              />
              <span className={active ? "text-espresso" : "text-espresso-light"}>{label}</span>
            </Link>
          );
        })}
        <button
          type="button"
          onClick={() => setDrawerOpen(true)}
          data-testid="mobile-nav-cart"
          className={
            "relative flex flex-col items-center justify-center gap-1 text-[10px] font-semibold "
            + "uppercase tracking-[0.12em] text-espresso"
          }
        >
          <span className="relative">
            <ShoppingBag size={19} strokeWidth={1.8} aria-hidden="true" />
            {count > 0 && (
              <span
                data-testid="mobile-nav-cart-count"
                className={
                  "absolute -right-3 -top-2 flex h-4 min-w-4 items-center justify-center "
                  + "rounded-full bg-espresso px-1 text-[9px] text-ivory"
                }
              >
                {count}
              </span>
            )}
          </span>
          <span>Bag</span>
        </button>
        {primaryLinks.slice(3).map(({ label, to, icon: Icon, testId }) => {
          const active = isCurrent(pathname, to);
          return (
            <Link
              key={to}
              to={to}
              data-testid={testId}
              aria-current={active ? "page" : undefined}
              className={
                "flex flex-col items-center justify-center gap-1 text-[10px] font-semibold "
                + "uppercase tracking-[0.12em]"
              }
            >
              <Icon
                size={19}
                strokeWidth={active ? 2 : 1.5}
                className={active ? "text-espresso" : "text-espresso-light"}
                aria-hidden="true"
              />
              <span className={active ? "text-espresso" : "text-espresso-light"}>{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}